/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from 'react';

import { useMediaQuery } from '@mui/material';

import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Tooltip from 'components/uiLibrary/Tooltip';
import Typography from 'components/uiLibrary/Typography';

import AggregationField from 'components/Globals/FormFields/AggregationField';

import { FILTER_AGGREGATION_SEARCH, PRODUCTIONS } from 'constants/endpointConstants';
import { TP, URL_SLUG_TYPES, AGGREGATION_TYPES } from 'constants/index';

import { getYearsCountFromOBStartingYear } from 'utils/globals';
import useAppContext from 'utils/hooks/useAppContext';

import { useTranslation } from 'src/i18n';

import classes from './SinceYearField.module.scss';

const SinceYearField = ({ value, queryParams, onChange, trackingData = {}, styles = {}, label }) => {
  const { t } = useTranslation('NS_CASTING_TOOL');
  const isMobile = useMediaQuery('(max-width: 1000px)');
  const { obRouteContext } = useAppContext();
  const { filters } = obRouteContext?.linkProps || {};

  const limit = useMemo(() => getYearsCountFromOBStartingYear(), []);

  const selectedValue = useMemo(() => {
    if (value && filters?.[URL_SLUG_TYPES.SINCE_YEAR]) {
      const year = value || filters?.[URL_SLUG_TYPES.SINCE_YEAR]?.[0]?.id;

      return [
        {
          id: year,
          label: year,
        },
      ];
    }

    return [];
  }, [value, filters]);

  return (
    <div className={classes.sinceYear}>
      <Typography size={12} weight="medium" className={classes.sinceYear__title}>
        {label || t(`${TP}.FN_SINCE`)}
        <Tooltip title={t(`${TP}.SINCE_YEAR_TOOLTIP_TITLE`)}>
          <span>
            <SpriteIcon icon="info_outline" size={14} className={classes.sinceYear__title_questionIcon} />
          </span>
        </Tooltip>
      </Typography>
      <AggregationField
        endpoint={FILTER_AGGREGATION_SEARCH(PRODUCTIONS)}
        aggregationType={AGGREGATION_TYPES.YEAR}
        selectedOptions={selectedValue}
        onChange={selectedYear => onChange(selectedYear?.id)}
        queryParams={{
          ...queryParams,
          limit,
        }}
        queryConfig={{
          cacheTime: 0,
        }}
        styles={styles}
        trackingData={trackingData}
        disableClearable
        popperStyles={classes.popperStyles}
        textFieldProps={{
          typingPlaceholder: t(`${TP}.TYPE_TO_SEARCH`),
          ...(isMobile && { placeholder: t(`${TP}.SEARCH_YEAR`) }),
        }}
        {...(isMobile && {
          mobileDrawerProps: {
            renderMobileOptions: (options, onChangeHandler) => (
              <div className={classes.sinceYear__drawerContent}>
                {options?.map(option => (
                  <div
                    key={option.id}
                    onClick={() => {
                      onChangeHandler(null, option);
                    }}
                    className={classes.sinceYear__drawerContent_optionLabel}
                  >
                    <Typography size={12} weight="medium">
                      {option?.label}
                    </Typography>
                    <SpriteIcon icon="chevron_right" size={16} />
                  </div>
                ))}
              </div>
            ),
            allowMobileDrawer: true,
            drawerHeaderTitle: t(`${TP}.FN_SINCE`),
          },
        })}
        renderMenuListItem={(props, option) => (
          <div {...props} className={classes.sinceYear__optionLabel}>
            <Typography size={14}>{option?.label}</Typography>
          </div>
        )}
      />
    </div>
  );
};

export default SinceYearField;
